import { FC, useContext, useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import { GroupBase, OptionsOrGroups } from "react-select";
import { Link } from "react-router-dom";

import AddCasePatientInformation from "../addCase/addCasePatientInformation";
import AddCasePatientAddress from "../addCase/addCasePatientAddress";
import AddCasePatientInsurances from "../addCase/addCasePatientInsurances";
import HubInputField from "../inputType";
import Document from "../addCase/documentUpload";

import useFetch from "src/hooks/useFetch";
import { addPatientDetails, resetPatientDetails } from "src/helpers/addCase";
import { LoaderContext } from "src/context/loaderContext";
import { CaseContext } from "src/context/caseContext";

import { APIEndpoints } from "src/types/apiTypes";
import {
  CaseStepTwoProps, PatientDetailType, PatientDropdownResponse,
  PracticeDropdownResponse, ProviderDropdownResponse
} from "./types";




const CaseStepTwo: FC<CaseStepTwoProps> = ({ control, isVisible, getValues, watch, setValue, trigger, resetField }): JSX.Element => {
  const [prevPatientId, setPrevPatientId] = useState(getValues("patient_attributes.global_patient_id"));
  // const [firstPracticeId] = useState(getValues("doctor_attributes.practice_id"));

  const { setLoader, hideLoader } = useContext(LoaderContext);
  const { currentCaseDraft } = useContext(CaseContext)

  const practiceId = watch("doctor_attributes.practice_id");
  const doctorId = watch("doctor_attributes.global_doctor_id");
  const globalPatientId = watch("patient_attributes.global_patient_id");
  const allUploadedDocuments = watch("uploaded_documents");



  const handleDocumentUpload = (fileData?: File) => {
    if (fileData) {
      const currentDocuments = getValues("uploaded_documents") || []; // Get current documents
      const updatedDocuments = [...currentDocuments, fileData]; // Add new document
      setValue("uploaded_documents", updatedDocuments); // Update form state
    } else {
      setValue("uploaded_documents", []);
    }
  };



  /**
   * @getPracticeDropdown api to get practice based listing
   * @first initialize the useFetch() hook
   * @second trigger practice listing api to get listing
   */
  const {data: practiceDropdownApiRes } = useFetch<PracticeDropdownResponse>(APIEndpoints.PRACTICE_DROPDOWN);


  const { data: globalDoctorsApiResponse, mutate: getGlobalDoctorsListing } =
    useFetch<ProviderDropdownResponse>(APIEndpoints.PROVIDER_DROPDOWN);

  /** @second */
  useEffect(() => {
    console.log("resetDoctorAndPatientDetails",practiceId,"    ",practiceDropdownApiRes)
    if (practiceId && practiceDropdownApiRes) {
      const globalDoctorParams = {
        practice_id: practiceId,
      };

      getGlobalDoctorsListing(null, null, globalDoctorParams);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [practiceId, practiceDropdownApiRes]);





 /**
   * @getPatientListingByDoctorId api to get patient listing from doctor id
   * @first initialize the useFetch() hook
   * @second calling patient api using selected doctor id
   * @third patient api success handler
   */
  const { error: patientListingApiError, data: patientListingApiResponse, mutate: getPatientListing } =
    useFetch<PatientDropdownResponse>(APIEndpoints.PATIENT_DROPDOWN);

  /** @second */
  useEffect(() => {
  if (practiceId && doctorId && globalDoctorsApiResponse) {
    const patientQueryParams = {
      practice_id: practiceId,
    };

    getPatientListing(null, null, patientQueryParams);
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [doctorId, globalDoctorsApiResponse]);

  /** @third */
  useEffect(() => {
    if (patientListingApiResponse || patientListingApiError)
      setValue("patient_attributes.global_patient_id", globalPatientId || 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patientListingApiResponse, patientListingApiError]);





  /**
   * @PatientDetailsById
   */
  const { data: patientDetailApiResponse, error: patientDetailApiError, mutate: getPatientById, removeErrorAndData: clearPatientDetails } =
    useFetch<PatientDetailType>(APIEndpoints.GET_PATIENT_DETAILS_BY_ID, {}, {}, false);

  useEffect(() => {
    if (typeof globalPatientId === "number" && prevPatientId !== globalPatientId) {
      setPrevPatientId(0);

      if (globalPatientId !== 0 && patientListingApiResponse) {
        if (!currentCaseDraft) {
          resetPatientDetails(setValue, globalPatientId);
          setLoader();
          clearPatientDetails();
          getPatientById(null, null, { global_patient_id: globalPatientId });
        }
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [globalPatientId, patientListingApiResponse]);

  useEffect(() => {
    if (patientDetailApiResponse || patientDetailApiError) {
      hideLoader();
      if (patientDetailApiResponse) {
        setPrevPatientId(patientDetailApiResponse.data.patient_info.id);
        addPatientDetails(setValue, patientDetailApiResponse);
        setValue("api_pa_approved", patientDetailApiResponse.data.pa_approved)
        if (patientDetailApiResponse.data.pa_approved) {
          resetField("uploaded_documents")
        }
        trigger(["patient_attributes", "insurances_attributes"]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patientDetailApiResponse, patientDetailApiError]);

  //:- Filling missing data into parent object
  useEffect(() => {
    if (practiceId) {
      const practiceData = practiceDropdownApiRes?.data.find((value) => value.id === practiceId);
      if (practiceData) setValue("practice_name", `${practiceData.name} - ${practiceData.address}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [practiceId]);

  useEffect(() => {
    if (doctorId) {
      const doctorObj = globalDoctorsApiResponse?.data.find((value) => value.id === doctorId);
      if (doctorObj) {
        setValue("doctor_fullname", doctorObj.fullname);
        setValue("doctor_firstlastname", doctorObj.first_last_name);
        //setSelectedDoctorObj(doctorObj);
      }
    } 
    // else {
    //     setSelectedDoctorObj(null);
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [doctorId, globalDoctorsApiResponse]);




  return (
    <div className={`${!isVisible ? 'd-none' : ''}`} style={{minHeight:'100vh'}}>
      <div className="card mb-3" >
        <div className="card-body">

          <div className="row">
            <div className="col-md-9 col-lg-10">
              <Controller
                name="doctor_attributes.practice_id"
                control={control}
                defaultValue={0}
                render={({ field, fieldState: { error } }) => (
                    <div className={"row"}>
                        <label className={"form-label col-lg-2 col-md-4 col-12 p-lg-0"}>Select a Practice *</label>
                        <div className={"col-lg-10 col-md-8 col-12"}>
                            <HubInputField
                                inputId="doctor_attributes.practice_id"
                                // inputLabel="Select a Practice"
                                inputPlaceholder="Select a Practice..."
                                isRequired={true}
                                isRowBased={true}
                                field={field}
                                error={error}
                                isDropdown={true}
                                isSearchable={false}
                                isTypeAhead
                                dropdownData={
                                    (practiceDropdownApiRes && practiceDropdownApiRes.data && practiceDropdownApiRes.data.length > 0 ?
                                            practiceDropdownApiRes.data.map((practice) => ({ label:  practice.address ? `${practice.name.charAt(0).toUpperCase() + practice.name.slice(1)} - ${practice.address}` : practice.name , value: practice.id }))
                                            : []
                                    ) as unknown as OptionsOrGroups<string, GroupBase<string>>
                                }
                            />
                        </div>
                    </div>
                )}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-md-9 col-lg-10">
              {practiceId ? (
                <Controller
                  name="doctor_attributes.global_doctor_id"
                  control={control}
                  defaultValue={0}
                  render={({ field, fieldState: { error } }) => (
                      <div className={"row"}>
                          <label className={"form-label col-lg-2 col-md-4 col-12 p-lg-0"}>Prescriber *</label>
                          <div className={"col-lg-10 col-md-8 col-12"}>
                              <HubInputField
                                  inputId="doctor_attributes.global_doctor_id"
                                  // inputLabel="Prescriber"
                                  inputPlaceholder="Select a Prescriber..."
                                  isRequired={true}
                                  isRowBased={true}
                                  field={field}
                                  error={error}
                                  isDropdown={true}
                                  isSearchable={false}
                                  isTypeAhead
                                  dropdownData={
                                      (globalDoctorsApiResponse && globalDoctorsApiResponse.data && globalDoctorsApiResponse.data.length > 0 ?
                                              globalDoctorsApiResponse.data.map((provider) => ({ value: provider.id, label: provider.fullname }))
                                              : []
                                      ) as unknown as OptionsOrGroups<string, GroupBase<string>>
                                  }
                              />
                          </div>
                      </div>
                  )}
                />
              ) : null}
            </div>
           {practiceId ?  <div className="col-md-3 col-lg-2">
              <Link to="/doctors/new" className="btn btn-primary">
                Add Prescriber
              </Link>
            </div> :null}
          </div>
          {doctorId ? (
            <Controller
              name="patient_attributes.global_patient_id"
              control={control}
              defaultValue={0}
              render={({ field, fieldState: { error } }) => (
                  <div className={"row"}>
                      <div className={"col-md-9 col-lg-10"}>
                        <div className={"row"}>
                            <label className={"form-label col-lg-2 col-md-4 col-12 p-lg-0"}>Select a Patient *</label>
                              <div className={"col-lg-10 col-md-8 col-12"}>
                                <HubInputField
                                  inputId="patient_attributes.global_patient_id"
                                  inputPlaceholder="(New Patient)..."
                                  isRequired={true}
                                  isRowBased={true}
                                  field={field}
                                  error={error}
                                  // inputLabel="Select a Patient"
                                  isDropdown={true}
                                  isSearchable={true}
                                  isTypeAhead
                                  dropdownData={
                                    (patientListingApiResponse && patientListingApiResponse.data && patientListingApiResponse.data.length > 0 ?
                                      [{ value: 0, label: `(New Patient)` }, ...patientListingApiResponse.data.map((patient) => ({ value: patient.id, label: patient.fullname }))]
                                      : [{ value: 0, label: `(New Patient)` }]
                                    ) as unknown as OptionsOrGroups<string, GroupBase<string>>
                                  }
                                />
                              </div>
                        </div>
                      </div>
                  </div>
              )}
            />
          ) : null}
        </div>
      </div>

      {doctorId ? (
        <>
          <Controller
            name="api_pa_approved"
            control={control}
            render={() => <></>}
          />

          {process.env.REACT_APP_ENV === "staging" ? (
            <div className="mb-3">
              <Document
                control={control}
                watch={watch}
                caseDocuments={allUploadedDocuments || []} // Pass current documents
                onUpload={handleDocumentUpload} // Pass callback to handle file selection
              />
            </div>
          ) : null}

          <AddCasePatientInformation control={control} watch={watch} getValues={getValues} setValue={setValue} trigger={trigger} />
          <AddCasePatientAddress control={control} watch={watch} getValues={getValues} setValue={setValue} />
          <AddCasePatientInsurances control={control} watch={watch} getValues={getValues} setValue={setValue} />
        </>
      ) : null}
    </div>
  );
};

export default CaseStepTwo;
